import { useEffect, useState } from 'react';

const AUTOMATIC_VIDEO_DELAY_MS = 15_000;

/**
 * Keeps the governed poster as the first-paint/LCP resource, then starts the
 * decorative Hero video after real interaction or a bounded kiosk fallback.
 * This preserves universal playback without making the multi-megabyte video
 * compete with the initial document, CSS and poster.
 */
export const useDeferredHeroVideo = (enabled: boolean): boolean => {
    const [shouldLoad, setShouldLoad] = useState(false);

    useEffect(() => {
        if (!enabled) {
            setShouldLoad(false);
            return;
        }

        let settled = false;
        const activate = () => {
            if (settled) return;
            settled = true;
            setShouldLoad(true);
            for (const eventName of interactionEvents) {
                window.removeEventListener(eventName, activate);
            }
        };
        const interactionEvents: Array<keyof WindowEventMap> = ['pointerdown', 'touchstart', 'keydown', 'scroll'];
        for (const eventName of interactionEvents) {
            window.addEventListener(eventName, activate, { passive: true, once: true });
        }

        const timer = window.setTimeout(activate, AUTOMATIC_VIDEO_DELAY_MS);
        return () => {
            window.clearTimeout(timer);
            for (const eventName of interactionEvents) {
                window.removeEventListener(eventName, activate);
            }
        };
    }, [enabled]);

    return shouldLoad;
};
